export enum ProviderEnrollmentViewEnum {
    NetworkProvider = 1,
    Provider = 2,
    InsuranceContract = 3,
    InsurancePlan = 4,
}